import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import aboutbanner from "../assets/aboutbanner.jpg";
import PosterOne from "../share/component.jsx/posterone";
import ConsultationForm from "../../components/services/ConsultationForm";
import BannerOne from "../share/component.jsx/banner";
import { useNavigate } from "react-router-dom";

const SERVICES = [
  {
    id: 1,
    image: require('../assets/services/World-Class Treatment Facilities.jpg'),
    title: "World-Class Treatment Facilities",
    desc: "We facilitate patients to reach internationally recognized cardiac hospitals with up-to-date facilities, advanced diagnosis, and specialized doctors. If you are asking for the best cardiac hospital near me or considering treatment in a foreign country, we can help you choose the appropriate option to meet your health, cost, and treatment requirements."
  },
  {
    id: 2,
     image: require('../assets/services/Pre-Evaluation & Referral Coordination.jpg'),
    title: "Pre-Evaluation & Referral Coordination",
    desc: "Our staff checks your medical history, test results, diagnosis, and treatment history before you begin travel. Then, we liaise with specialist cardiac cardiologists to recommend the proper treatment route. This assists patients in making an informed decision prior to their choice of heart disease treatment in China."
  },
  {
    id: 3,
    image: require('../assets/services/Visa & Travel Support.jpg'),
    title: "Visa & Travel Support",
    desc: "Traveling for medical reasons can be stressful without assistance. We provide medical visa advice, flight arrangements, hotel booking, airport transfers, and local travel arrangements. We are committed to making your journey smooth, safe, and comfortable from the get-go."
  },
  {
    id: 4,
    image: require('../assets/services/Hospital Liaison Services.jpg'),
    title: "Hospital Liaison Services",
    desc: "We serve as a means of communication between patients and hospitals in China. Our coordinators assist in the scheduling of appointments, the exchange of medical documents, updates on treatment progress, and supporting patients."
  },
  {
    id: 5,
    image: require('../assets/services/End-to-End Case Management.jpg'),
    title: "End-to-End Case Management",
    desc: "Our staff attends to your entire healthcare experience with personal care. We help you with the review of reports, the choice of doctors, communication with the hospital, travel arrangements, assistance with admission, coordination of treatment, and support in recovery."
  },
  {
    id: 6,
    image: require('../assets/services/Post-Surgery Virtual Follow-up.jpg'),
    title: "Post-Surgery Virtual Follow-up",
    desc: "Caring doesn't end after treatment in another country. We provide safe online post-discharge counseling for ongoing recovery. Medical experts can discuss with the patient the medication, reports, symptoms, progress towards recovery, and what should happen next."
  }
];

const DESTINATIONS = [
  { country: "Beijing", flag: "🇩", hospitals: "12+", specialty: "Advanced Interventional Cardiology" },
  { country: "Shanghai", flag: "🇨", hospitals: "15+", specialty: "Robotic Cardiac Surgery" },
  { country: "Guangzhou", flag: "🇯", hospitals: "8+", specialty: "Minimally Invasive Procedures" },
  { country: "Foshan", flag: "🇰", hospitals: "10+", specialty: "Complex Valve Repairs" },
  { country: "Shenzhen", flag: "🇹", hospitals: "6+", specialty: "Cardiac Rehabilitation" },
  { country: "Nanning", flag: "🇸", hospitals: "5+", specialty: "Heart Failure Management" }
];

const PROCESS = [
  { num: "01", title: "Initial Consultation", desc: "Give your medical reports, symptoms, diagnosis, current medications, and treatment needs to our team. We take the time to review the details of your case as well as understand your health goals and suggest the next step." },
  { num: "02", title: "Expert Matching", desc: "You are matched with the right cardiac experts who can assist you with the treatment for your heart ailment, based on where you reside and your medical history. This way, you can get targeted advice from more knowledgeable experts." },
  { num: "03", title: "Travel Planning", desc: "Once you have chosen the hospital/doctor, we assist you with your medical visa, travel arrangements, accommodation, appointments, and local arrangements for a hassle-free experience." },
  { num: "04", title: "Treatment Abroad", desc: "Our liaison support assists you during your treatment abroad with communicating with the hospital teams, understanding the treatment steps, managing documents, and providing proper care coordination." },
  { num: "05", title: "Safe Return", desc: "We support your recovery after treatment, organize your return, and provide ongoing care via virtual follow-up. This will help with recovery, medication management, and continuing medical care." }
];

function MedicalTourism() {
  const navigate = useNavigate();
  const [activeDest, setActiveDest] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setActiveDest(p => (p + 1) % DESTINATIONS.length), 4000);
    return () => clearInterval(t);
  }, []);

  return (
    <>
      <Helmet>
        <title>Best Cardiac Hospital &amp; Top Specialists Abroad</title>
        <meta
          name="description"
          content="Explore medical tourism for heart care. Find the best cardiac hospital near you, cardiologists in Germany, and top-rated cardiac specialists in China."
        />
      </Helmet>

      <BannerOne
        img={require('../assets/symptoms/tourismBanner.png')}
        title={
          <>
            Global Cardiac Access <br /> & <br />
            Medical Tourism
          </>
        }
      />
      <div className="service-root acc-root">
        {/* <PosterOne img={aboutbanner} title={"Global Cardiac Access & Medical Tourism"} /> */}
        

        <section className="service-section">
          <div className="service-container">
            <p className="service-eyebrow">Our Services</p>
            <h2 className="service-heading">Complete <em>Medical Tourism</em> Solutions</h2>
            <p className="service-subtitle">We offer all the medical tourism services to patients who are looking for trusted cardiac care in China. We facilitate access to top hospitals, world-class doctors, and cutting-edge treatment centers in China. We take care, clarity, and coordination of every step of your journey, from your initial consultation until you are safely back on the road.</p>
            <div className="service-grid">
              {SERVICES.map(s => (
                <div key={s.id} className="service-card">
                  {s.image ? (
                    <img
                      src={s.image}
                      alt={s.title}
                      style={{ width: 70, height: 70, objectFit: "cover", borderRadius: 18, marginBottom: 18 }}
                    />
                  ) : (
                    <div
                      style={{
                        width: 70,
                        height: 70,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: 18,
                        background: "#e8f0eb",
                        fontSize: 28,
                        marginBottom: 18,
                      }}
                    >
                      {s.icon || "📌"}
                    </div>
                  )}
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="service-section service-section-alt">
          <div className="service-container">
            <p className="service-eyebrow">Treatment Destinations</p>
            <h2 className="service-heading">Access to <em>World-Class</em> Cardiac Facilities</h2>
            <p className="service-subtitle">We bridge patients to partner hospitals in China in advanced Cardiovascular Care. These centers provide the services of experts, diagnosis, interventional, surgical care, and long-term heart health management. Patients seeking a top-rated cardiac specialist in China will be able to get advice on which hospital they should choose.</p>
            <div className="service-destinations">
              {DESTINATIONS.map((d, i) => (
                <div key={d.country} className={`service-dest ${activeDest === i ? 'active' : ''}`} onClick={() => setActiveDest(i)}>
                  {/* <div className="service-dest-flag">{d.flag}</div> */}
                  <div className="service-dest-country">{d.country}</div>
                  <div className="service-dest-hosp">{d.hospitals} hospitals</div>
                  <div className="service-dest-spec">{d.specialty}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="service-section">
          <div className="service-container">
            <p className="service-eyebrow">How It Works</p>
            <h2 className="service-heading">Your <em>Journey</em> to Better Heart Health</h2>
            <div className="service-process">
              {PROCESS.map(p => (
                <div key={p.num} className="service-process-step">
                  <div className="service-process-num">{p.num}</div>
                  <div className="service-process-title">{p.title}</div>
                  <div className="service-process-desc">{p.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="service-cta">
          <div className="service-container">
            <h2>Begin Your Journey to World-Class Heart Care</h2>
            <p>Reach out today to explore your cardiac medical tourism options in China. We will be reviewing your diagnosis, your treatment needs, and the stage your health journey is at, and connect you with the right specialists, hospitals, and travel support for a smooth and well-planned experience.
</p>
            <div className="service-btns" style={{ justifyContent: 'center' }}>
              <button className="service-btn-primary" onClick={() => navigate('/consultations')}>Get Started</button>
            </div>
          </div>
        </section>

      </div>
    </>
  );
}

export default MedicalTourism;
